export const initialForm = {
  name: "",
  lastname: "",
  email: "",
  password: "",
};
